<template>
  <div>
    <div>
      <image-asset-list
        :asset-list="payments"
        :global-image-path="baseAssetsUrl"
        type="payment"
      />
      <div
        id="errorOutput"
        class="input__error | input-error"
      />

      <input
        type="hidden"
        name="creditCardData.pseudocardpan"
        id="js-pseudocardpan"
      >
      <input
        type="hidden"
        name="creditCardData.truncatedcardpan"
        id="js-truncatedcardpan"
      >
      <input
        type="hidden"
        name="creditCardData.cardtype"
        id="js-cardtype"
      >
      <input
        type="hidden"
        name="creditCardData.cardexpiredate"
        id="js-cardexpiredate"
      >
      <div
        id="generalError"
        class="input__error | input-error"
      >
        {{ $t('checkout.payment_type.CREDITCARD.error') }}
      </div>
      <div class="form__group--row">
        <div class="form__col-3">
          <div class="input">
            <label class="input__label">
              {{ $t('checkout.payment.cardpan') }}
            </label>
            <div
              id="cardpan"
            />
          </div>
        </div>
        <div class="form__col-3 creditcard__cvc-field">
          <div class="input">
            <label class="input__label">
              {{ $t('checkout.payment.cvc') }}
            </label>
            <div
              id="cardcvc2"
            />
          </div>
        </div>
      </div>

      <div class="form__group--row">
        <div class="form__col-3">
          <div class="select">
            <span
              class="input__label input__label--static"
            >
              {{ $t('checkout.payment.expire_date') }}
            </span>
            <div class="form__group--row">
              <span
                id="cardexpiremonth"
                class="form__col-5"
              />
              <span
                id="cardexpireyear"
                class="form__col-7"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ImageAssetList from '../imageAssetList/imageAssetList.vue';
  import globalStateComputedMixin from '../../utilities/vueMixins/globalStateComputedMixin/globalStateComputedMixin.js';
  import * as scrollTo from 'scroll-to';
  import pigeon from "../../utilities/js/pigeon/pigeon";

  let iframes;


  export default {
    props: {
      initStepModel: {
        type: Object
      },
    },


    components: {
      ImageAssetList
    },

    mixins: [
      globalStateComputedMixin
    ],

    data() {
      return {
        stepModel: this.initStepModel,
        cardtype: '',
        inputstyle: 'display: block;width: 75%;height: 38px;padding: 8px 10px;font-size: 14px;line-height: 1.428571429;',
        selectstyle: 'display: block;height: 38px;padding: 8px 10px;font-size: 14px;line-height: 1.428571429;',
        supportedCardtypes: ["V", "M"],
        payments: [
          {
            name: 'payment_logo_visa.png',
            alt: 'visa'
          },
          {
            name: 'payment_logo_mastercard_square.png',
            alt: 'mastercard'
          }]
      }

    },
    mounted() {
      pigeon.subscribe('checkCreditCard', this.checkCreditCard.bind(this))

      document.querySelector('#generalError').style.display = "none";
      if (this.stepModel != null && Object.keys(this.stepModel).length) {

        const _this = this;

        let request, payconfig;
        payconfig = {
          fields: {
            cardpan: {
              selector: "cardpan",
              maxlength: "19",
              type: "text",
              style: this.inputstyle
            },
            cardcvc2: {
              selector: "cardcvc2",
              type: "password",
              style: this.inputstyle,
              size: "3",
              length: { "M": 3, "V": 3 },
              maxlength: "3",
              iframe: {
                width: "60px"
              }
            },
            cardexpiremonth: {
              selector: "cardexpiremonth",
              type: "select",
              size: "2",
              maxlength: "2",
              style: this.selectstyle,
              iframe: {
                width: "70px"
              }
            },
            cardexpireyear: {
              selector: "cardexpireyear",
              type: "select",
              style: this.selectstyle,
              iframe: {
                width: "80px"
              }
            },
            cardtype: {
              selector: "cardtype",
              cardtypes: this.supportedCardtypes
            }
          },
          defaultStyle: {
            input: "font-size: 1em; border: 1px solid #ccc; width: 100%;min-height:30px;max-width:100%;",
            select: "font-size: 1em; border: 1px solid #ccc;min-height:30px;",
            iframe: {
              height: "40px",
              width: "100%"
            }
          },
          autoCardtypeDetection: {
            supportedCardtypes: this.supportedCardtypes,
            callback: function (detectedCardtype) {
              // For the output container below.
              if (detectedCardtype === 'M') {
                _this.cardtype = detectedCardtype;
                _this.payments = [
                  {
                    name: 'payment_logo_mastercard.png',
                    alt: 'mastercard'
                  }]
              } else if (detectedCardtype === 'V') {
                _this.cardtype = detectedCardtype;
                _this.payments = [
                  {
                    name: 'payment_logo_visa.png',
                    alt: 'visa'
                  }]
              } else {
                _this.cardtype = '';
                _this.payments = [
                  {
                    name: 'payment_logo_visa.png',
                    alt: 'visa'
                  },
                  {
                    name: 'payment_logo_mastercard.png',
                    alt: 'mastercard'
                  }]
              }
            }

          },
          error: "errorOutput",
          language: window.Payone.ClientApi.Language.de
        };

        request = this.stepModel.payoneRequest;

        iframes = new window.Payone.ClientApi.HostedIFrames(payconfig, JSON.parse(request));

        this.showForm = true;
      }
    },
    methods: {
      checkCreditCard() {
        if (iframes.isComplete()) {
          document.querySelector('#generalError').style.display = "none";
          iframes.creditCardCheck('checkCallback');
        }
        if (document.querySelector("[name=paymentType]:checked").value === 'CREDIT_CARD') {
          if (!iframes.isComplete()) {
            window.scrollToElement('#generalError');
            document.querySelector('#generalError').style.display = "block";
          } else {
            document.querySelector('#generalError').style.display = "none";
          }
        }
      }
    }
  };

  window.checkCallback = function (response) {
    if (response.status === "VALID") {
      document.querySelector("#js-pseudocardpan").value = response.pseudocardpan;
      document.querySelector("#js-truncatedcardpan").value = response.truncatedcardpan;
      document.querySelector("#js-cardexpiredate").value = response.cardexpiredate;
      document.querySelector("#js-cardtype").value = response.cardtype;
      document.paymentbaseform.submit();
    } else {
      window.scrollToElement('#errorOutput');
    }
  };

  window.scrollToElement = function (elementSelector) {
    const firstErrorMessage = document.querySelector(elementSelector);
    const bodyRect = document.body.getBoundingClientRect();
    const elemRect = firstErrorMessage.parentElement.getBoundingClientRect();
    const scrollToPosition = elemRect.top - bodyRect.top - 100;
    scrollTo(0, scrollToPosition, { duration: 500 });
  };

</script>
